import { useState } from "react";
import { Link } from "react-router-dom";
import { forgotPassword } from "../api";
import { Row, Button, Form, Label, Col, Input, Container } from "reactstrap";

const ForgotPassword = () => {
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const [submitting, setSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        setError("");
        setMessage("");
        try {
            const data = await forgotPassword(email);
            setMessage(data.detail || "If an account exists, a reset link has been sent.");
        } catch (err) {
            const detail = err?.response?.data?.detail || "Unable to send reset email.";
            setError(Array.isArray(detail) ? detail.join(" ") : detail);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Container className="contain login-page auth-page d-flex justify-content-center align-items-center vh-100">
            <Row className="w-100 justify-content-center">
                <Col xs={12} sm={10} md={8} lg={5}>
                    <Form onSubmit={handleSubmit} className="auth-panel">
                        <Row className="g-3 flex-column text-center">
                            <Col>
                                <img
                                    src="/icon-lfx-192.svg"
                                    alt="Limitless FX"
                                    className="login-app-icon"
                                />
                            </Col>
                            <Col>
                                <strong className="login_header">Forgot Password</strong>
                            </Col>
                            <Col>
                                <Label className="visually-hidden" for="forgot-email">
                                    Email
                                </Label>
                                <Input
                                    id="forgot-email"
                                    name="email"
                                    placeholder="Email"
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                            </Col>
                            {message && <Col className="auth-success small">{message}</Col>}
                            {error && <Col className="auth-error small">{error}</Col>}
                            <Col>
                                <Button type="submit" disabled={submitting} className="brand-action-button">
                                    {submitting ? "Sending..." : "Send Reset Link"}
                                </Button>
                            </Col>
                            <Col>
                                <Link to="/login" className="auth-link">Back to Login</Link>
                            </Col>
                        </Row>
                    </Form>
                </Col>
            </Row>
        </Container>
    );
};

export default ForgotPassword;
